import * as React from "react";
import { connect } from "react-redux";

import PaymentMode from "../../screens/Settings/PaymentMode";
import {
  paymentmodelist,
  AddPaymentMode,
  EditPaymentMode,
  DeletePaymentMode,
  paymentmodeSlectedPage
} from "./action";
class PaymentModeContainer extends React.Component<Props, State> {
  render() {
    return (
      <PaymentMode
        paymentmodelist={this.props.paymentmodelist}
        PaymentmodeList={this.props.PaymentmodeList}
        PaymentmodeCount={this.props.PaymentmodeCount}
        AddPaymentMode={this.props.AddPaymentMode}
        EditPaymentMode={this.props.EditPaymentMode}
        DeletePaymentMode={this.props.DeletePaymentMode}
        paymentmodeSlectedPage={this.props.paymentmodeSlectedPage}
      />
    );
  }
}
function bindAction(dispatch) {
  return {
    paymentmodelist: () => {
      dispatch(paymentmodelist());
    },
    AddPaymentMode: value => {
      // console.log(value);
      dispatch(AddPaymentMode(value));
    },
    EditPaymentMode: value => {
      // console.log(value);
      dispatch(EditPaymentMode(value));
    },
    DeletePaymentMode: value => {
      dispatch(DeletePaymentMode(value));
    },
    paymentmodeSlectedPage: value => {
      dispatch(paymentmodeSlectedPage(value));
    }
  };
}
const mapStateToProps = state => {
  return {
    PaymentmodeList: state.PaymentModeReducer.PaymentmodeList,
    PaymentmodeCount: state.PaymentModeReducer.PaymentmodeCount
  };
};

export default connect(
  mapStateToProps,
  bindAction
)(PaymentModeContainer);
